document.addEventListener('DOMContentLoaded', function() {
  var links = document.querySelectorAll('.size-guide-link');
  var modal = document.getElementById('size-guide-modal');
  if (!links.length || !modal) return;
  var closeBtn = modal.querySelector('.size-guide-modal__close');

  links.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      modal.style.display = 'flex';
    });
  });

  closeBtn.addEventListener('click', function() {
    modal.style.display = 'none';
  });

  modal.addEventListener('click', function(e) {
    var content = modal.querySelector('.size-guide-modal__content');
    if (!content.contains(e.target)) {
      modal.style.display = 'none';
    }
  });
});
